import { Slice } from "gatsby";
import * as React from "react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import Button from "../Button/Button";
import Searcher from "../Searcher/Searcher";

const AsidePost: React.FC = (props: PropsWithChildren) => {
  const { t } = useTranslation("global");
  return (
    <aside className={`m-aside-post`}>
      <Searcher />
      <div className="sidebar-index">{props.children}</div>
      <div className="m-categories sidebar-block">
        {/*<span className="a-divider" />*/}
        <h3 className="a-category-title">{t("Categorías")}</h3>
        <div>
          <Slice alias={"categoryList"} render={"list"} />
        </div>
      </div>
      <div className="sidebar-block">
        {/*<span className="a-divider" />*/}
        <h3 className="a-category-title">{t("¿Hacemos galletas juntos?")}</h3>
        <Button
          fromRender={"aside-post"}
          arial={t("Abre un formulario de contacto")}
        >
          {t("Empezar proyecto")}
        </Button>
      </div>
    </aside>
  );
};

export default AsidePost;
